// Tenant-agnostic permission helper for the autowatch run Report.

// The run Report (report.json / report.md) section is internal — visible only to
// AppEsteem / Three Clicks staff, identified by the logged-in user's email domain.
const REPORT_EMAIL_DOMAINS = ['appesteem.com', 'threeclicks.ai'];

/**
 * Whether the given user may see the run Report section.
 * @param {{ email?: string } | null | undefined} user  the logged-in user
 * @returns {boolean}
 */
export function canSeeReport(user) {
  const email = user?.email;
  return !!email && REPORT_EMAIL_DOMAINS.some((d) => email.toLowerCase().endsWith(`@${d}`));
}
